import _defineProperty from "/workdir/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Q from 'q';
import Enums from './Enums.js';
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

var SWAP_PAGE_TIME = 200;
var fn = {};

function zoom($el, start, finish) {
  var deferred = Q.defer();
  $el.animate({
    'text-indent': 1
  }, {
    duration: 200,
    easing: 'swing',
    step: function step(now, fx) {
      fx.start = start;
      fx.end = finish;
      $el.css('transform', 'scale(' + now + ', ' + now + ')');
    },
    always: function always() {
      deferred.resolve($el);
    }
  });
  return deferred.promise;
}

function rotate($el, start, finish) {
  var deferred = Q.defer();
  $el.animate({
    'text-indent': 1
  }, {
    duration: 150,
    easing: 'swing',
    step: function step(now, fx) {
      fx.start = start;
      fx.end = finish;
      $el.css('transform', 'rotate(' + now + 'deg)');
    },
    always: function always() {
      deferred.resolve($el);
    }
  });
  return deferred.promise;
} // Note: It is necessary to pass in a success callback because we must
// remove the old dom node (and controller) in the same tick of the event
// loop. Waiting for "then" results in a glitchy animation.


fn.swapPages = function (options) {
  var deferred = Q.defer();
  var $parent = options.$parent;
  var $oldRoot = options.$oldRoot;
  var $newRoot = options.$newRoot;
  var success = options.success;
  var ctx = options.ctx;
  var directionClassName = 'transition-from-right';

  if (options.dir && options.dir === Enums.DIRECTION_BACK) {
    directionClassName = 'transition-from-left';
  }

  $newRoot.addClass(directionClassName);
  $parent.append($newRoot);
  $parent.addClass('animation-container-overflow');
  var newRootAnimations = {
    left: '0px',
    top: '0px',
    opacity: 1
  };
  $newRoot.animate(newRootAnimations, SWAP_PAGE_TIME, function () {
    $parent.removeClass('animation-container-overflow');
    $newRoot.removeClass(directionClassName);
    var clearStyles = Object.keys(newRootAnimations).reduce(function (styles, attr) {
      return _objectSpread(_objectSpread({}, styles), {}, _defineProperty({}, attr, ''));
    }, {});
    $newRoot.css(clearStyles);
    success.call(ctx);
    deferred.resolve();
  });
  $oldRoot.animate({
    height: $newRoot.height(),
    opacity: 0
  }, SWAP_PAGE_TIME * 0.8);
  return deferred.promise;
};

fn.swapBeacons = function (options) {
  var $el = options.$el;
  var swap = options.swap;
  var ctx = options.ctx;
  return this.implode($el).then(function () {
    swap.call(ctx);
    return $el;
  }).then(this.explode);
};

fn.explode = function ($el) {
  return zoom($el, 0, 1); //zoom in
};

fn.implode = function ($el) {
  return zoom($el, 1, 0); //zoom out
};

fn.radialProgressBar = function (options) {
  var radialProgressBar = options.$el;
  var swap = options.swap;
  var circles = radialProgressBar.children();
  return rotate(circles, 0, 180).then(function () {
    radialProgressBar.css({
      clip: 'auto'
    });
  }).then(function () {
    var leftHalf = circles.eq(0);
    swap();
    return rotate(leftHalf, 180, 360);
  }).then(function () {
    //reset values to initial state
    radialProgressBar.css({
      clip: 'rect(0px, 96px, 96px, 48px)'
    });
    circles.css({
      transform: 'rotate(0deg)',
      'text-indent': '1px'
    });
  });
};

export { fn as default };